"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeProvider = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const contexts_1 = require("../contexts");
const hooks_1 = require("../hooks");
const Theme_1 = require("./Theme");
/**
 * 🎨 ThemeProvider
 */
const ThemeProvider = (props) => {
    const BB = (0, hooks_1.useBlueBase)();
    const colorScheme = (0, hooks_1.useColorScheme)();
    const [, changeMode] = (0, hooks_1.useConfig)('theme.mode');
    const [themeName, changeTheme] = (0, hooks_1.useConfig)('theme');
    const [overridesConfig] = (0, hooks_1.useConfig)('theme.overrides');
    const key = props.theme || themeName;
    const mode = props.mode || colorScheme;
    const registryTheme = BB.Themes.getValue(key);
    if (!registryTheme) {
        BB.Logger.warn(`Could not load theme. Reason: Theme with the key "${key}" does not exist. Falling back to default theme.`);
    }
    const theme = new Theme_1.Theme(registryTheme, overridesConfig, props.overrides);
    theme.mode = mode;
    const value = {
        changeMode,
        changeTheme,
        theme,
    };
    return <contexts_1.ThemeContext.Provider value={value}>{props.children}</contexts_1.ThemeContext.Provider>;
};
exports.ThemeProvider = ThemeProvider;
exports.ThemeProvider.displayName = 'ThemeProvider';
exports.ThemeProvider.defaultProps = {
    overrides: {},
};
